export default function AuthLayout({ children }) {
  return (
    <>
      <header></header>
      {children}
    </>
  );
}
